import React, { Fragment, useState } from 'react'

import { useAdvertisementQuery } from '../../hooks/useAdvertisementQuery'
import { useIsMobileView } from '../../utils'

import './advertisement.scss'

/**
 * Get a random weighted advertisement object from the given data.
 *
 * @param {Array} data - An array of objects containing advertisement settings.
 * @returns {Object} - A randomly selected advertisement object based on weights.
 */
export const getRandomWeightedAdvertisement = data => {
  let ads = []

  // Filter and collect advertisements to show
  data?.forEach(ad => {
    const adsToShow = ad.data.advertisement.filter(_ad => _ad.showAd)

    ads = [...ads, ...adsToShow]
  })

  const weightedOptions = []

  // Create a weighted array based on 'rate' property
  ads.forEach(obj => {
    const rate = parseInt(obj.rate)

    if (!isNaN(rate)) {
      for (let i = 0; i < rate; i++) {
        weightedOptions.push(obj)
      }
    }
  })

  // Generate a random index and return the selected advertisement
  const randomIndex = Math.floor(Math.random() * weightedOptions.length)
  return weightedOptions[randomIndex]
}

export const Advertisement = ({
  height = '100%',
  width = '100%',
  margin = '0',
  className = '',
  size = 'medium',
  adplacement = null,
}) => {
  const [data] = useState(
    getRandomWeightedAdvertisement(useAdvertisementQuery(adplacement)),
  )

  const isMobileView = useIsMobileView()

  const adElement = hide => {
    const innerHtml =
      (data && data[hide ? 'medium' : size]) ||
      (!hide && size === 'large' && <div className="large-no-ads" />)

    return (
      (typeof innerHtml === 'string' && (
        <div
          className={`advertisement-container__${hide ? 'medium' : size} ${
            hide ? 'hidden' : ''
          } ${className}`}
          style={{
            margin,
            width,
            height,
          }}
          dangerouslySetInnerHTML={{
            __html: innerHtml,
          }}
        />
      )) ||
      innerHtml
    )
  }

  return (
    <Fragment>
      {adElement()}
      {size !== 'medium' && isMobileView && adElement(true)}
    </Fragment>
  )
}
